<template>
	<div>
		<div class="cnhotel-page">
	        <ul>
            <li class="last" @click="pre"><a href="javascript:void(0)">< 上一页</a></li>

	            <li :class="index==item.value?'active':''"
	            	v-for="item in list"
	            	v-show="item.show"
	            	@click="select(item)"
	            	><a href="javascript:void(0)">{{item.value}}</a></li>
	            <!-- <li>...</li> -->


            <li class="next" @click="next"><a href="javascript:void(0)">下一页 ></a></li>
	            <!-- <li class="none-border">
	                到第
	                <input type="text" id="page-num" v-model="page">
	                页
	            </li>
	            <li class="none-border button">
	                <div class="button" id="page-btn" @click="submit">确定</div>
	            </li> -->
	        </ul>
	    </div>
	</div>
</template>
<script>
	export default{
		name:'vue2-paginate',
		data(){
			return{
				list:[],
				size:10,
				index:0,
				total:0,
				page:''

			}
		},
		props:{
			pageIndex:{
				type:Number,
				default:0
			},
			pageSize:{
				type:Number,
				default:10
			},
			pageTotal:{
				type:Number,
				default:0,
			},
			pageShowCount:{
				type:Number,
				default:10,
			}
		},
		watch:{
			pageIndex(val){
				this.index=val;
			},
			pageSize(val){
				this.size=val;
			},
			pageTotal(val){
				this.total=val;
				this.initData();
			}
		},
		methods:{
			//初始化数据
			initData(){
				this.index=this.pageIndex;
				this.size=this.pageSize;
				this.total=this.pageTotal;
				this.initList();
			},
			//初始化列表显示
			initList(){
				var list=[];
				var index=this.index;
				var pageShowCount=this.pageShowCount;
				var total=this.total;

				if(index<pageShowCount-3){
					for(var i=1;i<=this.total;i++){
						var item={
							value:i==pageShowCount&&total>pageShowCount?'...':i,
							show:(i<=pageShowCount||i==total)?true:false,
						}
						list.push(item);
					}
				}else{
					for(var i=1;i<=total;i++){
						var isInclude=(i>=index-4&&i<=index+3)?true:false;
						var item={
							value:(i==1||i==total||!(i==(index-4)||i==(index+3))?i:'...'),
							show:(i==1||i==total||isInclude)?true:false,
						}
						list.push(item);
					}
				}
				this.list=list;
			},
			// 下一页
			next(){
				this.page='';
				this.index=(this.index+1>this.total?this.index:this.index+1);
				console.log(this.index+1>this.total)
				this.initList();
				this.$emit('select',this.index);
			},
			// 上一页
			pre(){
				this.page='';
				this.index=(this.index-1<1?this.index:this.index-1);
				this.initList();
				this.$emit('select',this.index);
			},
			// 跳到某一页
			submit(){

				this.index=Number(this.page);

				this.initList();
				this.$emit('select',this.index);
			},
			//选中页
			select(item){
				if(item.value>0){
					this.index=item.value;
					this.initList();
					this.$emit('select',this.index);
				}
			}

		},
		mounted(){
			this.initData();
		}
	}
</script>



// WEBPACK FOOTER //
// src/common/cmpnt/paginate/paginate.vue